export default {
  namespaced: true,
  state: {
    //filtros constantes
    si_filtered: false,
    si_current_filters: {},

    // Shipping Instruction
    // Por Enviar
    dataDataShippingInstructionPorEnviar: [],
    dataDataShippingInstructionPorEnviarInicial: [],
    dataDataShippingInstructionPorEnviarFiltrada: [],

    // Por aprobar
    dataDataShippingInstructionPorAprobar: [],
    dataDataShippingInstructionPorAprobarInicial: [],
    dataDataShippingInstructionPorAprobarFiltrada: [],

    // Por realizar
    dataDataShippingInstructionPorRealizar: [],
    dataDataShippingInstructionPorRealizarInicial: [],
    dataDataShippingInstructionPorRealizarFiltrada: [],

    // Enviadas
    dataDataShippingInstructionEnviadas: [],
    dataDataShippingInstructionEnviadasInicial: [],
    dataDataShippingInstructionEnviadasFiltrada: [],

    // Rechazadas
    dataDataShippingInstructionRechazadas: [],
    dataDataShippingInstructionRechazadasFiltrada: [],

    // Confirmadas
    dataDataShippingInstructionConfirmadas: [],
    dataDataShippingInstructionConfirmadasInicial: [],
    dataDataShippingInstructionConfirmadasFiltrada: [],

    // Templates
    dataDataShippingInstructionTemplates: [],
    dataDataShippingInstructionTemplatesFiltrada: [],

    // Reportes
    dataDataShippingInstructionReportes: [],
    dataDataShippingInstructionReportesFiltrada: [],

    listaNavieras: [],
    listaTodasNavieras: [],
    listarPuertos: [],
    listarPayers: [],
    listarContenedores: [],
    listarPackingTypes: [],

    /* CONTROL MODALS */

    //
    // Modal Informacion Shipping
    visibleModalInformacionShipping: false,
    visibleModalRejectShipping: false,
    // Modal Historial
    visibleModalHistorial: false,
    // Modal Editar Shipping
    visibleModalEditarShipping: false,

    showModalNewShippingFromBooking: false,

    visibleModalEditarTemplateShipping: false,
    // Modal Editar Template
    visibleModalEditarTemplate: false,
    // Modal Usar Template
    visibleModalUsarTemplate: false,

    visibleModalViewAcceptChanges: false,

    chargeTypes: [],
    movesTypes: [
      {
        id: '1',
        name: "PortToPort"
      },
      {
        id: '2',
        name: "DoorToPort"
      },
      {
        id: '3',
        name: "PortToDoor"
      },
      {
        id: '4',
        name: "DoorToDoor"
      }
    ],
    payers: [
      {
        id: "1",
        name: "Shipper"
      },
      {
        id: "2",
        name: "Consignee"
      },
      {
        id: "3",
        name: "Forwarder"
      },
      {
        id: "4",
        name: "Exporter"
      },
      {
        id: "5",
        name: "Importer"
      },
      {
        id: "6",
        name: "Freight Payer"
      },
    ],
    freightTerm: [
      {
        id: "1",
        name: "Collect",
      },
      {
        id: "2",
        name: "Prepaid",
      },
      {
        id: "3",
        name: "Payable Elsewhere",
      },
    ],
    weight_type: [
      {
        value: '1',
        label: "Kgm",
      },
      {
        value: '2',
        label: "Lbs",
      },
    ],
    chargesOptions: [
      {
        value: '1',
        label: "All Charges",
      },
      {
        value: '2',
        label: "Individual Charges",
      },
    ],
    blType: [
      {
        value: 'original',
        label: "Original",
      },
      {
        value: 'seaway_express',
        label: "Seaway/Express",
      },
      {
        value: 'standalone_house_bill',
        label: "This is a Standalone House Bill",
      },
    ],
    totalCountSteps: {
      shippingInstructionsPorEnviar: 0,
      shippingInstructionsEnviadas: 0,
      shippingInstructionsPorAprobar: 0,
      shippingInstructionsPorRealizar: 0,
      shippingInstructionsConfirmados: 0,
      shippingInstructionsRechazados: 0,
      shippingInstructionsTemplates: 0
    },
    totalCountStepsCharter: {
      shippingInstructionsPorEnviar: 0,
      shippingInstructionsEnviadas: 0,
      shippingInstructionsTemplates: 0
    },

  },
  // 2
  mutations: {
    setSIFiltered(state, payload) {
      state.si_filtered = payload;
    },
    setSICurrentFilters(state, payload) {
      state.si_current_filters = payload;
    },
    //
    /* CONTROL MODALS */
    //
    // Modal Informacion Shipping
    setVisibleModalInformacionShipping(state, payload) {
      state.visibleModalInformacionShipping = payload;
    },
    setVisibleModalRejectShipping(state, payload) {
      state.visibleModalRejectShipping = payload;
    },
    // Modal Historial
    setVisibleModalHistorial(state, payload) {
      state.visibleModalHistorial = payload;
    },
    // Modal Editar Shipping
    setVisibleModalEditarShipping(state, payload) {
      state.visibleModalEditarShipping = payload;
    },
    setShowModalNewShippingFromBooking(state, payload) {
      state.showModalNewShippingFromBooking = payload;
    },
    setVisibleModalEditarTemplateShipping(state, payload) {
      state.visibleModalEditarTemplateShipping = payload;
    },
    // Modal Editar Template
    setVisibleModalEditarTemplate(state, payload) {
      state.visibleModalEditarTemplate = payload;
    },
    // Modal Editar Template
    setVisibleModalUsarTemplate(state, payload) {
      state.visibleModalUsarTemplate = payload;
    },

    setVisibleModalViewAcceptChanges(state, payload) {
      state.visibleModalViewAcceptChanges = payload;
    },

    // Shipping Instruction
    // Por Enviar
    setDataDataShippingInstructionPorEnviar(state, payload) {
      state.dataDataShippingInstructionPorEnviar = payload;
    },
    setDataDataShippingInstructionPorEnviarInicial(state, payload) {
      state.dataDataShippingInstructionPorEnviarInicial = payload;
    },
    setDataDataShippingInstructionPorEnviarFiltrada(state, payload) {
      state.dataDataShippingInstructionPorEnviarFiltrada = payload;
    },

    // Por aprobar
    setDataDataShippingInstructionPorAprobar(state, payload) {
      state.dataDataShippingInstructionPorAprobar = payload;
    },
    setDataDataShippingInstructionPorAprobarInicial(state, payload) {
      state.dataDataShippingInstructionPorAprobarInicial = payload;
    },
    setDataDataShippingInstructionPorAprobarFiltrada(state, payload) {
      state.dataDataShippingInstructionPorAprobarFiltrada = payload;
    },

    // Por realizar
    setDataDataShippingInstructionPorRealizar(state, payload) {
      state.dataDataShippingInstructionPorRealizar = payload;
    },
    setDataDataShippingInstructionPorRealizarInicial(state, payload) {
      state.dataDataShippingInstructionPorRealizarInicial = payload;
    },
    setDataDataShippingInstructionPorRealizarFiltrada(state, payload) {
      state.dataDataShippingInstructionPorRealizarFiltrada = payload;
    },

    // Filtro *******************************************************
    // Por Enviar
    filterDataDataShippingInstructionPorEnviar(state, payload) {
      state.dataDataShippingInstructionPorEnviarFiltrada =
        state.dataDataShippingInstructionPorEnviar;
      state.dataDataShippingInstructionPorEnviarFiltrada = payload;
    },

    //por aprobar
    filterDataDataShippingInstructionPorAprobar(state, payload) {
      state.dataDataShippingInstructionPorAprobarFiltrada =
        state.dataDataShippingInstructionPorAprobar;
      state.dataDataShippingInstructionPorAprobarFiltrada = payload;
    },

    //por aprobar
    filterDataDataShippingInstructionPorRealizar(state, payload) {
      state.dataDataShippingInstructionPorRealizarFiltrada =
        state.dataDataShippingInstructionPorRealizar;
      state.dataDataShippingInstructionPorRealizarFiltrada = payload;
    },

    // Enviadas
    filterDataDataShippingInstructionEnviadas(state, payload) {
      state.dataDataShippingInstructionEnviadasFiltrada =
        state.dataDataShippingInstructionEnviadas;
      state.dataDataShippingInstructionEnviadasFiltrada = payload;
    },

    // Confirmadas
    filterDataDataShippingInstructionConfirmadas(state, payload) {
      state.dataDataShippingInstructionConfirmadasFiltrada =
        state.dataDataShippingInstructionConfirmadas;
      state.dataDataShippingInstructionConfirmadasFiltrada = payload;
    },
    // Rechazadas
    filterDataDataShippingInstructionRechazadas(state, payload) {
      state.dataDataShippingInstructionRechazadasFiltrada =
        state.dataDataShippingInstructionRechazadas;
      state.dataDataShippingInstructionRechazadasFiltrada = payload;
    },

    // Limpiar *******************************************************
    // Por Enviar
    limpiarDataDataShippingInstructionPorEnviar(state) {
      state.dataDataShippingInstructionPorEnviarFiltrada =
        state.dataDataShippingInstructionPorEnviar;
    },
    // Enviadas
    limpiarDataDataShippingInstructionEnviadas(state) {
      state.dataDataShippingInstructionEnviadasFiltrada =
        state.dataDataShippingInstructionEnviadas;
    },
    // Enviadas
    limpiarDataDataShippingInstructionConfirmadas(state) {
      state.dataDataShippingInstructionConfirmadasFiltrada =
        state.dataDataShippingInstructionConfirmadas;
    },
    limpiarDataDataShippingInstructionRechazadas(state) {
      state.dataDataShippingInstructionRechazadasFiltrada =
        state.dataDataShippingInstructionRechazadas;
    },

    /***********************************************************************/

    // Enviadas
    setDataDataShippingInstructionEnviadas(state, payload) {
      state.dataDataShippingInstructionEnviadas = payload;
    },
    setDataDataShippingInstructionEnviadasInicial(state, payload) {
      state.dataDataShippingInstructionEnviadasInicial = payload;
    },
    setDataDataShippingInstructionEnviadasFiltrada(state, payload) {
      state.dataDataShippingInstructionEnviadasFiltrada = payload;
    },

    // Rechazadas
    setDataDataShippingInstructionRechazadas(state, payload) {
      state.dataDataShippingInstructionRechazadas = payload;
    },
    setDataDataShippingInstructionRechazadasFiltrada(state, payload) {
      state.dataDataShippingInstructionRechazadasFiltrada = payload;
    },
    // Confirmadas
    setDataDataShippingInstructionConfirmadas(state, payload) {
      state.dataDataShippingInstructionConfirmadas = payload;
    },
    setDataDataShippingInstructionConfirmadasInicial(state, payload) {
      state.dataDataShippingInstructionConfirmadasInicial = payload;
    },
    setSataDataShippingInstructionConfirmadasFiltrada(state, payload) {
      state.dataDataShippingInstructionConfirmadasFiltrada = payload;
    },
    // Templates
    setDataDataShippingInstructionTemplates(state, payload) {
      state.dataDataShippingInstructionTemplates = payload;
    },
    setDataDataShippingInstructionTemplatesFiltrada(state, payload) {
      state.dataDataShippingInstructionTemplatesFiltrada = payload;
    },
    // Reportes
    setDataDataShippingInstructionReportes(state, payload) {
      state.dataDataShippingInstructionReportes = payload;
    },
    setDataDataShippingInstructionReportesFiltrada(state, payload) {
      state.dataDataShippingInstructionReportesFiltrada = payload;
    },

    // Listas

    setListaNavieras(state, payload) {
      state.listaNavieras = payload;
    },
    setListaTodasNavieras(state, payload) {
      state.listaTodasNavieras = payload;
    },
    setListarPuertos(state, payload) {
      state.listarPuertos = payload;
    },
    setListarPayers(state, payload) {
      state.listarPayers = payload;
    },
    setListarContenedores(state, payload) {
      state.listarContenedores = payload;
    },
    setListarPackingTypes(state, payload) {
      state.listarPackingTypes = payload;
    },

    setChargeTypes(state, payload) {
      state.chargeTypes = payload;
    },

    setTotalCountSteps(state, payload) {
      state.totalCountSteps = payload;
    },

    setTotalCountStepsCharter(state, payload) {
      state.totalCountStepsCharter = payload;
    },

  },

  // 1
  actions: {
    //
    actionSetSIFiltered({ commit }, data) {
      commit("setSIFiltered", data);
    },
    actionSetSICurrentFilters({ commit }, data) {
      commit("setSICurrentFilters", data);
    },

    /* CONTROL MODALS */

    // Modal Informacion Shipping
    actionSetVisibleModalInformacionShipping({ commit }, data) {
      commit("setVisibleModalInformacionShipping", data);
    },
    actionSetVisibleModalRejectShipping({ commit }, data) {
      commit("setVisibleModalRejectShipping", data);
    },
    // Modal Historial
    actionSetVisibleModalHistorial({ commit }, data) {
      commit("setVisibleModalHistorial", data);
    },
    actionSetShowModalNewShippingFromBooking({ commit }, data) {
      commit("setShowModalNewShippingFromBooking", data);
    },
    // Modal Editar Shipping
    actionSetVisibleModalEditarShipping({ commit }, data) {
      commit("setVisibleModalEditarShipping", data);
    },
    // Modal Editar Template Shipping
    actionSetVisibleModalEditarTemplateShipping({ commit }, data) {
      commit("setVisibleModalEditarTemplateShipping", data);
    },
    // Modal Editar Template
    actionSetVisibleModalEditarTemplate({ commit }, data) {
      commit("setVisibleModalEditarTemplate", data);
    },
    // Modal Usar Template
    actionSetVisibleModalUsarTemplate({ commit }, data) {
      commit("setVisibleModalUsarTemplate", data);
    },

    actionSetVisibleModalViewAcceptChanges({ commit }, data) {
      commit("setVisibleModalViewAcceptChanges", data);
    },

    // Shipping Instruction
    // Por Enviar
    actionSetDataDataShippingInstructionPorEnviar({ commit }, data) {
      commit("setDataDataShippingInstructionPorEnviar", data);
    },
    actionSetDataDataShippingInstructionPorEnviarInicial({ commit }, data) {
      commit("setDataDataShippingInstructionPorEnviarInicial", data);
    },
    actionSetDataDataShippingInstructionPorEnviarFiltrada({ commit }, data) {
      commit("setDataDataShippingInstructionPorEnviarFiltrada", data);
    },

    //por aprobar
    actionSetDataDataShippingInstructionPorAprobar({ commit }, data) {
      commit("setDataDataShippingInstructionPorAprobar", data);
    },
    actionSetDataDataShippingInstructionPorAprobarInicial({ commit }, data) {
      commit("setDataDataShippingInstructionPorAprobarInicial", data);
    },
    actionSetDataDataShippingInstructionPorAprobarFiltrada({ commit }, data) {
      commit("setDataDataShippingInstructionPorAprobarFiltrada", data);
    },

    //por realizar
    actionSetDataDataShippingInstructionPorRealizar({ commit }, data) {
      commit("setDataDataShippingInstructionPorRealizar", data);
    },
    actionSetDataDataShippingInstructionPorRealizarInicial({ commit }, data) {
      commit("setDataDataShippingInstructionPorRealizarInicial", data);
    },
    actionSetDataDataShippingInstructionPorRealizarFiltrada({ commit }, data) {
      commit("setDataDataShippingInstructionPorRealizarFiltrada", data);
    },

    // Enviadas
    actionSetDataDataShippingInstructionEnviadas({ commit }, data) {
      commit("setDataDataShippingInstructionEnviadas", data);
    },
    actionSetDataDataShippingInstructionEnviadasInicial({ commit }, data) {
      commit("setDataDataShippingInstructionEnviadasInicial", data);
    },
    actionSetDataDataShippingInstructionEnviadasFiltrada({ commit }, data) {
      commit("setDataDataShippingInstructionEnviadasFiltrada", data);
    },
    // Rechazadas
    actionSetDataDataShippingInstructionRechazadas({ commit }, data) {
      commit("setDataDataShippingInstructionRechazadas", data);
    },
    actionSetDataDataShippingInstructionRechazadasFiltrada({ commit }, data) {
      commit("setDataDataShippingInstructionRechazadasFiltrada", data);
    },
    // Confirmadas
    actionSetDataDataShippingInstructionConfirmadas({ commit }, data) {
      commit("setDataDataShippingInstructionConfirmadas", data);
    },
    actionSetDataDataShippingInstructionConfirmadasInicial({ commit }, data) {
      commit("setDataDataShippingInstructionConfirmadasInicial", data);
    },
    actionSetDataDataShippingInstructionConfirmadasFiltrada({ commit }, data) {
      commit("setDataDataShippingInstructionConfirmadasFiltrada", data);
    },
    // Templates
    actionSetDataDataShippingInstructionTemplates({ commit }, data) {
      commit("setDataDataShippingInstructionTemplates", data);
    },
    actionSetDataDataShippingInstructionTemplatesFiltrada({ commit }, data) {
      commit("setDataDataShippingInstructionTemplatesFiltrada", data);
    },
    // Reportes
    actionSetDataDataShippingInstructionReportes({ commit }, data) {
      commit("setDataDataShippingInstructionReportes", data);
    },
    actionSetDataDataShippingInstructionReportesFiltrada({ commit }, data) {
      commit("setDataDataShippingInstructionReportesFiltrada", data);
    },

    // Filtro *******************************************************
    // Por Enviar

    actionFilterDataDataShippingInstructionPorEnviar({ commit }, data) {
      commit("filterDataDataShippingInstructionPorEnviar", data);
    },

    // Enviadas
    actionFilterDataDataShippingInstructionEnviadas({ commit }, data) {
      commit("filterDataDataShippingInstructionEnviadas", data);
    },

    // Confirmadas
    actionFilterDataDataShippingInstructionConfirmadas({ commit }, data) {
      commit("filterDataDataShippingInstructionConfirmadas", data);
    },

    // Rechazadas
    actionFilterDataDataShippingInstructionRechazadas({ commit }, data) {
      commit("filterDataDataShippingInstructionRechazadas", data);
    },

    // Limpiar *******************************************************
    // Por Enviar
    actionLimpiarDataDataShippingInstructionPorEnviar({ commit }, data) {
      commit("limpiarDataDataShippingInstructionPorEnviar", data);
    },

    // Enviadas
    actionLimpiarDataDataShippingInstructionEnviadas({ commit }, data) {
      commit("limpiarDataDataShippingInstructionEnviadas", data);
    },

    // Confirmadas
    actionLimpiarDataDataShippingInstructionConfirmadas({ commit }, data) {
      commit("limpiarDataDataShippingInstructionConfirmadas", data);
    },

    // Rechazadas
    actionLimpiarDataDataShippingInstructionRechazadas({ commit }, data) {
      commit("limpiarDataDataShippingInstructionRechazadas", data);
    },

    actionSetTotalCountSteps({ commit }, data) {
      commit("setTotalCountSteps", data);
    },

    actionSetTotalCountStepsCharter({ commit }, data) {
      commit("setTotalCountStepsCharter", data);
    },

    /**************************************************************************/

    // Listas
    actionSetListaNavieras({ commit }, data) {
      commit("setListaNavieras", data);
    },
    actionSetListaTodasNavieras({ commit }, data) {
      commit("setListaTodasNavieras", data);
    },
    actionSetListarPuertos({ commit }, data) {
      commit("setListarPuertos", data);
    },
    actionSetListarPayers({ commit }, data) {
      commit("setListarPayers", data);
    },
    actionSetListarContenedores({ commit }, data) {
      commit("setListarContenedores", data);
    },
    actionSetListarPackingTypes({ commit }, data) {
      commit("setListarPackingTypes", data);
    },
    actionSetChargeTypes({ commit }, data) {
      commit("setChargeTypes", data);
    },
  },
};
